import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

// Most-recent featured guests, mirrored from HintonMagazine.com's
// "In Conversation With..." rail. Slug must match backend guest slug.
const GUESTS = [
  {
    name: "Hiyäm Jabak & Frédéric Charland",
    slug: "hiyam-jabak-frederic-charland",
    photo: "/icw-hiyam-jabak-frederic-charland.jpg",
    role: "Founders, HIYÄM Wellness",
  },
  {
    name: "Simona Ray",
    slug: "simona-ray",
    photo:
      "https://static.wixstatic.com/media/9edac4_545abae1775c472aa262630fb7e305cd~mv2.jpg/v1/fill/w_500,h_625,al_c,q_85,enc_avif,quality_auto/simona-ray.jpg",
    role: "Artist",
  },
  {
    name: "Christy Swaid",
    slug: "christy-swaid",
    photo:
      "https://static.wixstatic.com/media/9edac4_07abb39b967d4fed89409f944e0c7a0a~mv2.jpg/v1/fill/w_500,h_625,al_c,q_85,enc_avif,quality_auto/christy-swaid.jpg",
    role: "Athlete & Entrepreneur",
  },
  {
    name: "Liam J. Wakefield",
    slug: "liam-j-wakefield",
    photo:
      "https://static.wixstatic.com/media/9edac4_12b1999860e44b7ea555e1995bc55a8b~mv2.jpg/v1/fill/w_500,h_625,al_c,q_85,enc_avif,quality_auto/liam-wakefield.jpg",
    role: "Psychologist",
  },
];

export function InConversationWith() {
  return (
    <section
      className="px-4 sm:px-6 lg:px-10 py-16 md:py-24 bg-[#F2EFE7] border-y border-black/10"
      data-testid="in-conversation-with"
    >
      <div className="flex items-end justify-between border-b border-black/20 pb-5 mb-10 md:mb-14">
        <div>
          <div className="overline text-[var(--hinton-red)] mb-2">The Long Read</div>
          <h2 className="font-display text-3xl sm:text-5xl md:text-6xl font-black tracking-[-0.04em] leading-[0.9]">
            In Conversation With…
          </h2>
          <p className="mt-4 max-w-xl text-neutral-700 text-base md:text-lg leading-relaxed font-serif-ed italic">
            Long-form interviews with the founders, authors, doctors and creatives shaping the next decade.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 md:gap-8">
        {GUESTS.map((g) => (
          <Link
            key={g.slug}
            to={`/in-conversation-with/${g.slug}`}
            className="article-card group block"
            data-testid={`icw-guest-${g.slug}`}
          >
            <div className="zoom-img aspect-[4/5] bg-neutral-200 relative overflow-hidden">
              <img
                src={g.photo}
                alt={g.name}
                loading="lazy"
                className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-[filter] duration-700"
              />
            </div>
            <div className="pt-4">
              <div className="font-serif-ed font-semibold text-lg md:text-xl leading-tight tracking-tight group-hover:text-[var(--hinton-red)] transition-colors">
                {g.name}
              </div>
              <div className="mt-1 text-xs font-mono-ed uppercase tracking-[0.18em] text-neutral-600">
                {g.role}
              </div>
            </div>
          </Link>
        ))}
      </div>

      <div className="mt-12 md:mt-16 flex justify-center">
        <Link
          to="/in-conversation-with"
          className="inline-flex items-center gap-3 bg-black text-white px-8 py-4 text-xs uppercase tracking-[0.24em] font-bold hover:bg-[var(--hinton-red)] transition-colors"
          data-testid="icw-see-all"
        >
          See all conversations <ArrowUpRight size={14} />
        </Link>
      </div>
    </section>
  );
}

